'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});
var VALIDATOR_ARG_ERROR_MESSAGE = 'The typeValidator argument must be a function with the signature function(props, propName, componentName).',
  MESSAGE_ARG_ERROR_MESSAGE = 'The error message is optional, but must be a string if provided.',
  propIsRequired = function propIsRequired(a, b, c, d) {
    if ('boolean' == typeof a) return a;
    return 'function' == typeof a ? a(b, c, d) : !(!0 !== !!a) && !!a;
  },
  propExists = function propExists(a, b) {
    return Object.hasOwnProperty.call(a, b);
  },
  missingPropError = function missingPropError(a, b, c, d) {
    return d ? new Error(d) : new Error('Required ' + a[b] + ' `' + b + '`' + (' was not specified in `' + c + '`.'));
  },
  guardAgainstInvalidArgTypes = function guardAgainstInvalidArgTypes(a, b) {
    if ('function' != typeof a) throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);
    if (!!b && 'string' != typeof b) throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE);
  },
  isRequiredIf = function isRequiredIf(a, b, c) {
    return guardAgainstInvalidArgTypes(a, c), function (d, e, f) {
      for (var _len = arguments.length, g = Array(3 < _len ? _len - 3 : 0), _key = 3; _key < _len; _key++) g[_key - 3] = arguments[_key];
      return propIsRequired(b, d, e, f) ? propExists(d, e) ? a.apply(void 0, [d, e, f].concat(g)) : missingPropError(d, e, f, c) : a.apply(void 0, [d, e, f].concat(g)); // Is not required, so just run typeValidator.
    };
  };
exports.default = isRequiredIf;